import { PaginationParamsType } from "./message"



export interface Technical {
  [key: string]: any
}


export type FAESearchStatusValues ='' | 'OPEN' |'IN_PROGRESS' | 'RESOLVED' |'CLOSED' |'REOPENDED'

export type FAESearchTimerValues = null | 'currentDay' | 'lastDay1' | 'lastDay7' | 'customize'

export interface FAEOrderStatusItem {
  id?: FAESearchStatusValues | FAESearchTimerValues,
  name: string,
  count?: number,
  [data:string]:any
}

type Pick<T,K extends keyof T> ={
  [P in K]:T[P]
}



export interface FAESearchForm extends PaginationParamsType{
  timeRangeType?: FAESearchTimerValues,
  status?: FAESearchStatusValues,
  keywordOrSn?: string
  timeRange?: {
    startTime:any,
    endTime:any
  },


}

export interface FAEOrderTableItem {
  sn:string,
  title:string
  productType:string,
  status:FAESearchStatusValues,
  proposeTime:string,
  lastUpdateTime:string
  statusName?:string
  proposeTimeFormat?:string,
  operation:any
  key?:any
  id?:any
}


export enum FAEOrderStatus{
  WAIT_AUDIT='WAIT_AUDIT',
  PROCESSING='PROCESSING',
  PROCESSED='PROCESSED',
  ADOPTED='ADOPTED'
}